import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag, Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import { useBusiness } from "../context/BusinessContext";

export default function Navbar() {
  const { count } = useCart();
  const { business } = useBusiness();
  const [q, setQ] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setSearchOpen(false);
  }, [location.pathname]);

  const submitSearch = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    navigate(`/shop?search=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header
      className="sticky top-0 z-40 bg-[#f5f5f0]/80 backdrop-blur border-b border-neutral-900/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            {business.logo_url ? (
              <img src={business.logo_url} alt="" className="h-7 w-7 object-contain" />
            ) : (
              <span className="w-7 h-7 bg-black inline-block" />
            )}
            <span className="font-black text-lg tracking-tighter">
              {business.name || "SHOP"}
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8 text-xs uppercase tracking-ultra">
            <Link to="/" className="hover:text-accent transition-colors" data-testid="nav-home">
              Home
            </Link>
            <Link to="/shop" className="hover:text-accent transition-colors" data-testid="nav-shop">
              Shop
            </Link>
            <Link to="/shop?featured=true" className="hover:text-accent transition-colors" data-testid="nav-featured">
              Featured
            </Link>
            <Link to="/admin" className="hover:text-accent transition-colors" data-testid="nav-admin">
              Admin
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            <button
              onClick={() => setSearchOpen((v) => !v)}
              className="p-2 hover:text-accent transition-colors"
              aria-label="Toggle search"
              data-testid="toggle-search-button"
            >
              {searchOpen ? <X className="w-4 h-4" /> : <Search className="w-4 h-4" />}
            </button>
            <Link
              to="/cart"
              className="relative p-2 hover:text-accent transition-colors"
              data-testid="cart-icon-link"
            >
              <ShoppingBag className="w-5 h-5" />
              {count > 0 && (
                <span
                  className="absolute -top-0.5 -right-0.5 bg-accent text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center"
                  data-testid="cart-count-badge"
                >
                  {count}
                </span>
              )}
            </Link>
          </div>
        </div>
        {searchOpen && (
          <form onSubmit={submitSearch} className="pb-4 flex gap-2" data-testid="search-form">
            <input
              autoFocus
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search products..."
              className="flex-1 border-b border-black bg-transparent py-2 outline-none focus:border-b-2 placeholder:text-neutral-400"
              data-testid="search-input"
            />
            <button
              type="submit"
              className="bg-black text-white px-5 text-xs uppercase tracking-ultra"
              data-testid="search-submit-button"
            >
              Go
            </button>
          </form>
        )}
      </div>
    </header>
  );
}
